import React from 'react';
import { m } from 'framer-motion';
import { ShieldCheckIcon, MailIcon, ClockIcon, HelpCircleIcon } from 'lucide-react';
const items = [{
  icon: HelpCircleIcon,
  text: 'Sin preguntas. No te pedimos explicaciones.'
}, {
  icon: MailIcon,
  text: 'Sin formularios. Solo un email y listo.'
}, {
  icon: ClockIcon,
  text: 'Devolución en 24h. Rápido y sin drama.'
}];
export function Guarantee() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-118" data-mp="2edsznq7j8t9c">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-119" data-mp="2efduzi1o8g89">
        <m.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="rounded-3xl border border-success/25 bg-bg-primary p-8 sm:p-10" data-id="element-120" data-mp="2jajfccffdmu8">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-success/10" data-id="element-121" data-mp="txy15ii554c0">
            <ShieldCheckIcon size={32} className="text-success" data-id="element-122" data-mp="xzt38p7wblqu" />
          </div>
          <h2 className="mt-5 font-heading text-2xl font-bold uppercase leading-tight text-white sm:text-3xl" data-id="element-123" data-mp="3slybit3v8je8">
            Garantía Total de 14 Días
          </h2>
          <p className="mt-2 text-lg font-medium text-success" data-id="element-124" data-mp="3nsvh6ir9l5wz">Si no es para ti, te devolvemos el 100%.</p>
          <p className="mx-auto mt-4 max-w-xl text-sm leading-relaxed text-muted sm:text-base" data-id="element-125" data-mp="3dwk59tvl6i32">
            Prueba el material sin ningún riesgo. Revisa los 6 tomos. Usa el Kit de Implementación. Si en 14
            días no sientes que El Manual del Entrenador de Baloncesto ha mejorado tu planificación y la
            calidad de tus sesiones, escríbenos a{' '}
            <a href="mailto:manualeslistos@gmail.com" className="font-medium text-orange underline" data-id="element-126" data-mp="5f5vdsqoftpq">
              manualeslistos@gmail.com
            </a>{' '}
            y te devolvemos el importe completo en menos de 24 horas.
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-3" data-id="element-127" data-mp="2l84ph54mrvqo">
            {items.map(item => <div key={item.text} className="flex flex-col items-center gap-2 rounded-2xl bg-white/5 p-4" data-id="element-128" data-mp="1d8p9v996t7p2">
                <item.icon size={20} className="text-orange" data-id="element-129" data-mp="1haj87avwtzm2" />
                <p className="text-xs leading-relaxed text-white/90 sm:text-sm" data-id="element-130" data-mp="1h7wyb4ljr80o">{item.text}</p>
              </div>)}
          </div>

          <p className="mt-6 text-xs text-muted sm:text-sm" data-id="element-131" data-mp="188jqegd2mri2">
            Más de 8.000 entrenadores ya lo usan. Nuestra tasa de devolución es menor al 1%.
          </p>
        </m.div>
      </div>
    </section>;
}